import UpgamingApi from './UpgamingApi'

export default UpgamingApi
